/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as s from "react";
import { Button as r } from "@progress/kendo-react-buttons";
import { FindAndReplaceDialog as c } from "../dialogs/FindReplace.mjs";
import { onDownPreventDefault as d } from "./utils.mjs";
import { messages as m } from "../messages/index.mjs";
import { EditorToolsSettings as p } from "../config/toolsSettings.mjs";
import { provideLocalizationService as g, registerForLocalization as h } from "@progress/kendo-react-intl";
import { classNames as f } from "@progress/kendo-react-common";
const n = p.findAndReplace;
let u = class extends s.Component {
  constructor() {
    super(...arguments), this.state = { showDialog: !1 }, this.onClose = () => this.setState({ showDialog: !1 }), this.onOpen = () => this.setState({ showDialog: !0 });
  }
  /**
   * @hidden
   */
  render() {
    const { view: e, ...t } = this.props, { props: i } = n, l = g(this), a = n.messages.findReplaceToolTitle, o = !e;
    return [/* @__PURE__ */ s.createElement(
      r,
      {
        onClick: o ? void 0 : this.onOpen,
        "aria-disabled": o ? !0 : void 0,
        ...d,
        title: l.toLanguageString(a, m[a]),
        key: "tool",
        ...i,
        ...t,
        className: f(t.className, i.className, { "k-disabled": o })
      }
    ), this.state.showDialog && e && /* @__PURE__ */ s.createElement(
      c,
      {
        view: e,
        onClose: this.onClose,
        dir: t.dir,
        key: "dialog"
      }
    )];
  }
};
h(u);
export {
  u as FindAndReplace
};
